import {Component, Input, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router, RouterLink} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {switchMap, tap} from "rxjs/operators";
import {UserConfigService} from "../auth/user-config.service";
import {environment} from '../../environments/environment';
import {AuthService} from '../auth/auth.service';
import {AsyncPipe, NgIf} from '@angular/common';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css'],
    imports: [
        HelpDocsLinksComponent,
        AsyncPipe,
        NgbDropdownModule,
        NgIf,
        RouterLink
    ]
})
export class NavigationComponent implements OnInit {
  user: Observable<any>;
  public adminUrl = `${environment.local_service_endpoint}/admin/`;

  constructor(private authService: AuthService, private userConfigService: UserConfigService,
              private router: Router) {
  }

  ngOnInit() {
    this.user = this.userConfigService.config;
  }

  logout() {
    this.authService.logout().pipe(tap(() => this.router.navigate(['login']))).subscribe();
  }
}
